import clsx from 'clsx';
import styles from './Container.module.scss';
import { useMemo, type ReactNode } from 'react';
import { ContainerContext, type ContainerContextValue } from './ContainerContext';

interface Props {
  children: ReactNode;
  color?: 'default' | 'error';
}

export function Container({ children, color = 'default' }: Props) {
  const value = useMemo<ContainerContextValue>(() => ({}), []);

  return (
    <ContainerContext.Provider value={value}>
      <div className={clsx(styles['container'], styles['color-' + color])}>
        {children}
      </div>
    </ContainerContext.Provider>
  );
}
